import { deprecated } from 'typesafe-actions';
const { createStandardAction } = deprecated;

export const setFilterValue = createStandardAction('shared/SET_FILTER_VALUE')<{ name: string, value: any }>();